import React, { useRef, useState } from "react";

import lazySizes from "lazysizes";

const Picture = (props) => {
    const {
        image,
        imageMobile,
        className,
        onClick,
        breakpoint,
        noLazy,
        height,
        width,
    } = props;
    // const [size, setSize] = useState({ height: "", width: "" });
    // const imgRef = useRef();

    // const url = process.env.GATSBY_ASSETS_ENDPOINT;

    const supportFormatWebp = () => {
        var elem = document.createElement("canvas");

        if (elem.getContext && elem.getContext("2d")) {
            // Was able or not to get WebP representation
            return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } else {
            // Very old browser like IE 8, canvas not supported
            return false;
        }
    };

    const returnValue = (values, key) => {
        if (key === "src") {
            if (supportFormatWebp) {
                return values && values.sources && values.sources[0].srcset
                    ? values.sources[0].srcset
                    : values && values[key]
                    ? values[key]
                    : "";
            }
        }
        return values && values[key] ? values[key] : "";
    };

    const webpSort = (sources) => {
        if (typeof sources === "undefined" || !sources) return false;
        sources.sort((a, b) => {
            if (a.type === "image/webp") {
                return -1;
            }
            return 1;
        });
        return sources;
    };

    // const handleImageLoad = event => {
    //   setSize({
    //     height: event.target.clientHeight,
    //     width: event.target.clientWidth,
    //   });
    //   console.log(size);
    // };

    return (
        <picture>
            {(webpSort(image?.sources) || []).map((img, index) => {
                return (
                    <source
                        key={index}
                        data-srcset={img.srcset}
                        type={img.type}
                        media={`(min-width:${
                            breakpoint ? breakpoint + "px" : "768px"
                        })`}
                    ></source>
                );
            })}

            {(webpSort(imageMobile?.sources) || []).map((img, index) => {
                return (
                    <source
                        key={index}
                        data-srcset={img.srcset}
                        type={img.type}
                        media={`(max-width:${
                            breakpoint ? breakpoint + "px" : "768px"
                        })`}
                    ></source>
                );
            })}
            <source
                data-srcset={returnValue(imageMobile, "src")}
                type={returnValue(imageMobile, "type")}
                media={`(max-width:${
                    breakpoint ? breakpoint + "px" : "768px"
                })`}
            ></source>

            <img
                // ref={imgRef}
                // onLoad={handleImageLoad}
                width={width}
                height={height}
                // loading={noLazy ? "" : "lazy"}
                className={`lazyload ${className}`}
                onClick={onClick}
                title={returnValue(image ? image : imageMobile, "title")}
                alt={returnValue(image ? image : imageMobile, "alt")}
                data-src={returnValue(image ? image : imageMobile, "src")}
            ></img>
        </picture>
    );
};

export default Picture;
